<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入模板名称进行搜索" prefix-icon="el-icon-search"
                              clearable
                              @clear="initTemplates"
                              style="width: 350px;margin-right: 10px" v-model="searchValue.scanTemplateName"
                              @keydown.enter.native="initTemplates"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initTemplates">
                        搜索
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddTemplateView">
                        扫码模板
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="templates"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
<!--                <el-table-column-->
<!--                        type="selection"-->
<!--                        min-width="3%">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="scanTemplateId"
                        align="left"
                        label="模板编号"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="scanTemplateName"
                        label="模板名称"
                        align="left"
                        min-width="20%">
                </el-table-column>
                <el-table-column
                        prop="scanTemplateType"
                        label="类型"
                        align="center"
                        :formatter="typeFormat"
                        min-width="8%">
                </el-table-column>
                <el-table-column
                        prop="scanTemplateBatchCode"
                        min-width="12%"
                        align="center"
                        label="批次数/码量">
                </el-table-column>
                <el-table-column
                        prop="scanTemplateStatus"
                        min-width="9%"
                        align="center"
                        label="状态">
                    <template slot-scope="scope">
                        <div>
                            <i class="el-icon-success" :style="{'color': (scope.row.scanTemplateStatus=='1'? '#67c23A':'#606266')}" ></i>
                            {{scope.row.idCard}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="scanTemplateCheckStatus"
                        min-width="11%"
                        align="center"
                        label="审核状态">
                    <template slot-scope="scope">
                        <div>
                            <i class="el-icon-success" :style="{'color': (scope.row.scanTemplateCheckStatus=='1'? '#67c23A':'#606266')}" ></i>
                            {{scope.row.wedlock}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="scanTemplateCreatetime"
                        min-width="15%"
                        align="center"
                        :formatter="formatDate"
                        label="添加时间">
                </el-table-column>
                <el-table-column
                        min-width="15%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
<!--                        <el-popover placement="right" title="" style="padding-right: 10px" trigger="hover">-->
<!--                            <img style="padding: 3px; width: 150px; height: 150px;" :src="scope.row.scanTemplateUrl" />-->
<!--                            <el-button slot="reference" style="padding: 3px" size="mini" type="success">预览</el-button>-->
<!--                        </el-popover>-->
                        <el-button @click="showPreviewTemplateView(scope.row)" slot="reference" style="padding: 3px" size="mini" type="success">预览</el-button>
                        <el-button @click="showUpdateTemplateView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteTemplate(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
            <div style="padding: 25px">
                <div class="templateBottom">
                    <p style="height: 8px">说明:</p>
                    <p style="height: 5px">1.</p>
                    <p style="height: 5px">2.</p>
                    <p style="height: 5px">3.</p>
                </div>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogAddVisible"
                width="80%">
            <div>
                <el-form :model="template" :rules="rules" ref="templateAddForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="模板名称:" prop="scanTemplateName">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="template.scanTemplateName"
                                      placeholder="请输入模板名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型:" prop="scanTemplateType" style="padding-left: 50px">
                            <el-radio-group v-model="template.scanTemplateType" class="templateType">
                                <el-radio label="1" >关联码</el-radio>
                                <el-radio label="2" >营销码</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-transfer
                                v-model="transferValue"
                                :data="transferData"
                                :titles="['模块列表', '已选模块']"
                                :button-texts="['去除', '增加']"></el-transfer>
                    </el-form-item>
<!--                    <el-upload class="templateUpload"-->
<!--                               ref="addUpload"-->
<!--                               action="/qrm/template/add"-->
<!--                               list-type="picture-card"-->
<!--                               :class="{hide:hideAddUpload}"-->
<!--                               :file-list="fileAddList"-->
<!--                               :limit="1"-->
<!--                               :data="template"-->
<!--                               :auto-upload="false"-->
<!--                               accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"-->
<!--                               :on-success="doAddSuccess"-->
<!--                               :on-change="handleAddChange"-->
<!--                               :on-preview="handleAddPictureCardPreview"-->
<!--                               :on-remove="handleAddRemove">-->
<!--                        <i class="el-icon-plus"></i>-->
<!--                    </el-upload>-->
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAddTemplate(template)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogUpdateVisible"
                width="80%">
            <div>
                <el-form :model="template" :rules="rules" ref="templateUpdateForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="模板名称:" prop="scanTemplateName">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="template.scanTemplateName"
                                      placeholder="请输入模板名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型:" prop="scanTemplateType" style="padding-left: 100px">
                            <el-radio-group v-model="template.scanTemplateType" class="templateType">
                                <el-radio label="1" >关联码</el-radio>
                                <el-radio label="2" >营销码</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-transfer
                                v-model="transferValue"
                                :data="transferData"
                                :titles="['模块列表', '已选模块']"
                                :button-texts="['去除', '增加']"></el-transfer>
                    </el-form-item>
<!--                    <el-upload class="templateUpload"-->
<!--                               ref="updateUpload"-->
<!--                               action="/qrm/template/update"-->
<!--                               list-type="picture-card"-->
<!--                               :class="{hide:hideUpdateUpload}"-->
<!--                               :file-list="fileUpdateList"-->
<!--                               :limit="1"-->
<!--                               :data="template"-->
<!--                               :auto-upload="false"-->
<!--                               accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"-->
<!--                               :on-success="doUpdateSuccess"-->
<!--                               :on-preview="handleUpdatePictureCardPreview">-->
<!--                        <i class="el-icon-plus"></i>-->
<!--                    </el-upload>-->
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateVisible = false">取 消</el-button>
                <el-button type="primary" @click="doUpdateTemplate(template)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogPreviewVisible"
                width="60%">
            <div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogPreviewVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "QRMTemplate",
        inject: ['reload'],
        data() {
            return {
                searchValue: {
                    scanTemplateName: ''
                },
                title: '',
                templates: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                action: '',
                fileAddList: [],
                fileUpdateList: [],
                hideAddUpload: false, // 控制选择框是否显示的开关
                hideUpdateUpload: false,
                dialogAddImageUrl: '',
                dialogUpdateImageUrl: '',
                dialogAddVisible: false,
                dialogUpdateVisible: false,
                dialogPreviewVisible: false,
                transferData: [],
                transferValue: [],
                template: {
                    scanTemplateId: 0,
                    scanTemplateName: "",
                    scanTemplateType: "1",
                    sacnTemplateModule: []
                },
                rules: {
                    scanTemplateName: [{required: true, message: '请输入模板名称', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.initTemplates();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initTemplates();//获取列表数据
                }
            }
        },
        methods: {
            formatDate(row, column) {
                // 获取单元格数据
                let scanTemplateCreatetime = row.scanTemplateCreatetime;
                if(scanTemplateCreatetime == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                let date = new Date(scanTemplateCreatetime.replace(pattern, '$1-$2-$3 $4:$5:$6'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                return Y+M+D+h+m+s;
            },
            typeFormat(row, column){
                if (row.scanTemplateType=='1') {
                    return "关联码";
                } else if (row.scanTemplateType=='2') {
                    return "营销码";
                }
                return "关联码";
            },
            showAddTemplateView() {
                this.title = '添加扫码模板';
                this.emptyTemplate();
                var _this = this;
                this.getRequest("/qrm/template/listModule").then(resp => {
                    _this.loading = false;
                    if (resp) {
                        _this.transferData = [];
                        for (let i = 0; i <= resp.data.length; i++) {
                            _this.transferData.push({
                                key: resp.data[i].key,
                                label: resp.data[i].label,
                                disabled: resp.data[i].disabled
                            });
                        }
                    }
                });
                this.dialogAddVisible = true;
            },
            // handleAddChange (file, fileAddList) {
            //     this.hideAddUpload = fileAddList.length > 0
            // },
            // handleAddRemove (file, fileAddList) { // 防止出场动画未结束，选择框提前出现
            //     setTimeout(() => {
            //         this.hideAddUpload = fileAddList.length > 0
            //     }, 520)
            // },
            // handleAddPictureCardPreview (file) {
            //     this.dialogAddImageUrl = file.url
            //     this.dialogAddVisible = true
            // },
            // doAddSuccess(res, file) {
            //     if (res) {
            //         this.dialogAddVisible = false;
            //         this.initTemplates();
            //     }
            // },
            doAddTemplate(template) {
                if(template){
                    template.sacnTemplateModule = this.transferValue;
                    this.$refs['templateAddForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/qrm/template/addTemplate", template).then(resp => {
                                if (resp) {
                                    this.dialogAddVisible = false;
                                    this.initTemplates();
                                }
                            })
                        }
                    });
                }
                // if(this.hideAddUpload){
                //     this.$refs.addUpload.submit();
                //     this.initTemplates();
                //     // this.$refs.addUpload.clearFiles();
                //     // this.hideAddUpload = this.fileAddList.length > 0;
                //     // this.dialogAddVisible = false;
                // }else {
                //     if(template){
                //         this.$refs['templateAddForm'].validate(valid => {
                //             if (valid) {
                //                 this.postRequest("/qrm/template/addNoTemplate", template).then(resp => {
                //                     if (resp) {
                //                         this.dialogAddVisible = false;
                //                         this.initTemplates();
                //                     }
                //                 })
                //             }
                //         });
                //     }
                // }
            },
            showUpdateTemplateView(data) {
                this.title = '编辑模板信息';
                this.emptyTemplate();
                this.template = data;
                // this.fileUpdateList.length = 0;
                // this.fileUpdateList.push({
                //     name: this.template.scanTemplateFilename,
                //     url: this.template.scanTemplateUrl
                // })
                var _this = this;
                this.getRequest("/qrm/template/listModule?scanTemplateId="+data.scanTemplateId).then(resp => {
                    _this.loading = false;
                    if (resp) {
                        _this.transferData = [];
                        _this.transferValue = [];
                        for (let i = 0; i <= resp.data.length; i++) {
                            _this.transferData.push({
                                key: resp.data[i].key,
                                label: resp.data[i].label,
                                disabled: resp.data[i].disabled
                            });
                            if(resp.data[i].selected){
                                _this.transferValue.push(resp.data[i].key);
                            }
                        }
                    }
                });
                this.dialogUpdateVisible = true;
            },
            // handleUpdateChange (file, fileUpdateList) {
            //     this.hideUpdateUpload = fileUpdateList.length > 0
            // },
            // handleUpdateRemove (file, fileUpdateList) { // 防止出场动画未结束，选择框提前出现
            //     setTimeout(() => {
            //         this.hideUpdateUpload = fileUpdateList.length > 0
            //     }, 520)
            // },
            // handleUpdatePictureCardPreview (file) {
            //     this.dialogUpdateImageUrl = file.url
            //     this.dialogUpdateVisible = true
            //     this.hideUpdateUpload = fileUpdateList.length > 0
            // },
            // doUpdateSuccess(res, file) {
            //     if (res) {
            //         this.dialogUpdateVisible = false;
            //         this.initTemplates();
            //     }
            // },
            doUpdateTemplate(template) {
                if(template){
                    this.$refs['templateUpdateForm'].validate(valid => {
                        if (valid) {
                            template.sacnTemplateModule = this.transferValue;
                            this.postRequest("/qrm/template/updateTemplate", template).then(resp => {
                                if (resp) {
                                    this.dialogUpdateVisible = false;
                                    this.initTemplates();
                                }
                            })
                        }
                    });
                }
                // if(this.fileUpdateList.length > 0){
                //     this.$refs.updateUpload.$children[0].post(file);
                //     this.initTemplates();
                //     this.$refs.updateUpload.clearFiles();
                //     // this.hideUpdateUpload = this.fileUpdateList.length > 0;
                //     this.dialogUpdateVisible = false;
                // }else {
                // }
            },
            showPreviewTemplateView(data) {
                this.title = '模板预览';
                this.template = data;
                this.dialogPreviewVisible = true;
            },
            deleteTemplate(data) {
                this.$confirm('此操作将永久删除【' + data.scanTemplateName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let param = new FormData(); //创建form对象
                    param.append('scanTemplateId', data.scanTemplateId);
                    this.postRequest("/qrm/template/delete", param).then(resp => {
                        if (resp) {
                            this.initTemplates();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            emptyTemplate() {
                this.template = {
                    scanTemplateId: 0,
                    scanTemplateName: "",
                    scanTemplateType: "1",
                    sacnTemplateModule: []
                }
                this.transferData = [];
                this.transferValue = [];
            },
            initTemplates() {
                this.loading = true;
                let url = '/qrm/template/listByPage?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.scanTemplateName) {
                    url += '&scanTemplateName=' + this.searchValue.scanTemplateName;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.templates = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTemplates();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTemplates();
            }
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .templateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .templateType{
        margin-top: 8px;
    }

    .templateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>